import React, { useEffect, useState } from 'react';
import proptypes from 'prop-types';
import { RatingReviewPageLinks } from '@thd-olt-component-react/search-page-links';
import {
  arrayOf,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import * as analytics from '../../ratings-reviews-analytics';
import { usePresentation } from '../../context/PresentationProvider';

const { func, number, shape, string } = proptypes;

const trackPaginationEvent = () => {
  analytics.track('event', {
    origin: 'ratings and reviews',
    location: 'pagination',
    eventType: 'click'
  });
};

export const ReviewPager = ({
  itemId = null,
  onPageChanged,
  reviewsPageContext,
  statistics = null,
  storeId = null,
  category = ''
}) => {
  const [pageContext, setPageContext] = useState(reviewsPageContext);
  const { useCondensedLayout } = usePresentation();
  const channel = useCondensedLayout ? 'mobile' : 'desktop';

  useEffect(() => {
    onPageChanged(pageContext);
  }, [pageContext]);

  const totalReviews = statistics?.totalResults || 0;
  const { totalPages = 1, currentPage = 1 } = pageContext || {};

  return (
    <RatingReviewPageLinks
      itemId={itemId}
      storeId={storeId}
      totalReviews={totalReviews}
      category={category}
      channel={channel}
      paginationProps={{
        count: totalPages,
        page: currentPage,
        fullWidth: channel === 'mobile',
        onChange: (event, value) => {
          setPageContext({ ...pageContext, currentPage: value });
          trackPaginationEvent();
        }
      }}
    />
  );
};

ReviewPager.displayName = 'ReviewPager';

ReviewPager.propTypes = {
  itemId: string,
  storeId: string,
  onPageChanged: func.isRequired,
  category: string,
  statistics: shape({
    totalResults: number
  }),
  reviewsPageContext: shape({
    totalPages: number,
    currentPage: number,
    pageNeighbours: number
  }).isRequired
};

ReviewPager.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    dataSources: stringType(),
    identifiers: shapeType({
      canonicalUrl: stringType()
    })
  }),
  storeSearch: params({
    storeSearchInput: stringType().isRequired(),
    pagesize: stringType().isRequired()
  }).shape({
    stores: arrayOf(shapeType({
      storeDetailsPageLink: stringType()
    }))
  })
};
